import React, { useEffect, useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { track } from '@amplitude/analytics-browser'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'
import { useDispatch } from 'react-redux'
import URL from 'src/api/url'

const HeaderSettingsTheme = ({
  classes,
  landingPageData,
  themeSettings,
  onThemeSettingsChange,
}) => {
  const dispatch = useDispatch()
  // Track if initialization has happened
  const [initialized, setInitialized] = useState(false)
  const pageUrl = window.location.pathname.split('/')[1]

  // Initialize theme settings from landing page data only once
  useEffect(() => {
    // Only initialize if we haven't done so yet and we have landingPageData
    if (landingPageData && !initialized) {
      const content = landingPageData?.sections?.[0]?.content || {}

      // Set our initialization flag to prevent overriding user selections
      setInitialized(true)

      // Only set default values if not already set in themeSettings
      if (!themeSettings.selectedPosition) {
        onThemeSettingsChange('selectedPosition', content.alignment || 'center')
      }

      if (!themeSettings.background) {
        onThemeSettingsChange('background', content.image || '')
      }
    }
  }, [landingPageData, themeSettings, onThemeSettingsChange, initialized])

  // Open media gallery modal
  const handleAddImage = () => {
    track('media_gallery_in_editor_clicked')

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
              <Icon icon="ic:round-add-a-photo" color="#00AB55" width="24" height="24" />
              <Typography style="margin-left: 8; color: #002E47; fontWeight: 600; fontSize: 16;">
                Media Gallery
              </Typography>
            </div>
          `,
          component: (
            <ContainerMediaGalery
              onOk={items => {
                onThemeSettingsChange('background', items[0].url)
                dispatch(messageBoxHideAction('message-box-1'))
              }}
              setImageURL={() => {}}
            />
          ),
          draggable: true,
          maxHeight: '70vh',
        }),
      ),
    )
  }

  // Handle position selection
  const handlePositionSelect = position => {
    onThemeSettingsChange('selectedPosition', position)
  }

  // Position option styles
  const getPositionStyle = position => {
    return {
      border:
        themeSettings.selectedPosition === position
          ? '1px solid var(--mcg-blue, #015FFB)'
          : '1px solid var(--Gray-Lighter, #E5E7EB)',
    }
  }
  const background =
    themeSettings.background === null ||
    themeSettings.background === '' ||
    themeSettings.background === undefined
      ? 'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png'
      : themeSettings.background.includes('http')
      ? themeSettings.background
      : URL.CDN + themeSettings.background

  // Position options data
  const positionOptions = [
    { value: 'left', label: 'Left' },
    { value: 'center', label: 'Center' },
    { value: 'right', label: 'Right' },
  ]

  return (
    <div className={classes.container}>
      {/* Header section */}
      <div className={classes.headerContent}>
        <div className={classes.headerContainer}>
          <Typography className={classes.header}>Theme settings</Typography>
        </div>
        <div className={classes.typeContainer}>
          <Typography className={classes.type}>Default type</Typography>
        </div>
      </div>

      {/* Image section */}
      <div className={classes.imageContent}>
        <div className={classes.imageContainer}>
          <Typography className={classes.imageHeader}>Header image</Typography>
        </div>
        <div
          className={classes.background}
          style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
                        url(${
                          background || ''
                        }) lightgray 50% / cover no-repeat`,
          }}
        >
          <div className={classes.button} onClick={handleAddImage}>
            <Typography className={classes.buttonText}>Change image</Typography>
          </div>
        </div>
        <div className={classes.imageContent}>
          <Typography className={classes.imageText}>
            For the best results on all devices, use an image with a maximum
            size of 6 MB and a minimum resolution of 2048x1152px
          </Typography>
        </div>
      </div>

      {/* Alignment section */}
      <div className={classes.imageContent}>
        <div className={classes.imageContainer}>
          <Typography className={classes.imageHeader}>
            Content alignment
          </Typography>
        </div>
        <div className={classes.imageContent}>
          <Typography className={classes.imageText}>
            Choose how the logo, title, and button are positioned over the
            header image.
          </Typography>
        </div>

        {/* Position options */}
        <div className={classes.positionContainer}>
          {positionOptions.map(option => (
            <div className={classes.positionDiv} key={option.value}>
              <div
                className={classes.positionContent}
                onClick={() => handlePositionSelect(option.value)}
                style={getPositionStyle(option.value)}
              >
                <img
                  src={`/assets/editor-file/landing-page/${
                    pageUrl === 'collection' ? 'collection' : 'course'
                  }/${option.value}.svg`}
                  alt={`${option.label} alignment`}
                />
              </div>
              <div className={classes.positionTextDiv}>
                <Typography className={classes.positionText}>
                  {option.label}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsTheme)
